import React, { Component } from 'react'
import { Switch, Route, Redirect, BrowserRouter as Router } from 'react-router-dom'
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles'
import MuiPickersUtilsProvider from 'material-ui-pickers/utils/MuiPickersUtilsProvider'
import MomentUtils from 'material-ui-pickers/utils/moment-utils'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import GlobalMessageSnackbar from './common/global-message-snackbar'
import green from '@material-ui/core/colors/green'
import red from '@material-ui/core/colors/red'
import routes, { userRoutes, adminRoutes, accountRoutes, publicMenuRoutes, superAdminRoutes } from './routes'
import NotFound from './common/not-found'
import * as localesActions from './store/locales'
import * as accountActions from './store/accounts'
import * as pageActions from './store/page'

const mapStateToProps = state => ({
  locales: state.locales,
  accounts: state.accounts
})
const mapDispatchToProps = dispatch => ({
  localesActions: bindActionCreators(localesActions, dispatch),
  accountActions: bindActionCreators(accountActions, dispatch),
  pageActions: bindActionCreators(pageActions, dispatch)
})

const hylteTheme = createMuiTheme({
  palette: {
    primary: green,
    secondary: red
  },
  colors: {
    danger: '#F0675D',
    warning: '#F4E471',
    success: '#6ABFA3'
  },
  ripple: {
    color: 'forestgreen'
  },
  typography: {
    fontFamily: ['Quicksand', 'sans-serif'].join(',')
  }
})

const superAdminRoles = ['SuperAdmin']
const adminRoles = ['Admin', 'SuperAdmin']
const userRoles = ['Admin', 'SuperAdmin', 'User']

const ProtectedRoute = ({ component: Component, allowedRoles: roles, isAuthenticated, role, ...rest }) => (
  <Route
    {...rest}
    render={props =>
      (isAuthenticated
        ? roles.includes(role)
            ? <Component {...props} />
            : <Redirect
              to={{
                pathname: '/notfound',
                state: { from: props.location }
              }}
              />
        : <Redirect
          to={{
            pathname: '/login',
            state: { from: props.location }
          }}
          />)}
  />
)

class App extends Component {
  componentDidMount () {
    if (!this.props.locales.locales || !this.props.locales.language) {
      var host = this.extractRootDomain(window.location.hostname).split('.')
      if (host.length === 2) {
        this.props.localesActions.setLanguage(host[1])
        this.props.localesActions.setCountry(host[1] === 'fi' ? 'Finland' : 'Sweden')
      } else {
        this.props.localesActions.setLanguage('en')
        this.props.localesActions.setCountry('Sweden')
      }
    }

    const token = localStorage.getItem('id_token')

    if (token && !this.props.accounts.isAuthenticated) {
      this.props.accountActions.profileFromToken(token)
    }
  }

  extractRootDomain (hostname) {
    var domain = hostname, splitArr = domain.split('.'), arrLen = splitArr.length

    // extracting the root domain here
    // if there is a subdomain
    if (arrLen > 2) {
      domain = splitArr[arrLen - 2] + '.' + splitArr[arrLen - 1]
      // check to see if it's using a Country Code Top Level Domain (ccTLD) (i.e. ".me.uk")
      if (splitArr[arrLen - 2].length === 2 && splitArr[arrLen - 1].length === 2) {
        // this is using a ccTLD
        domain = splitArr[arrLen - 3] + '.' + domain
      }
    }

    return domain
  }

  render () {
    const { locales, accounts } = this.props
    const theme = hylteTheme

    if (!locales.locales) return null
    return (
      <Router>
        <MuiThemeProvider theme={theme}>
          <MuiPickersUtilsProvider utils={MomentUtils}>
            <div
              className={'stripe'}
              style={{ borderColor: theme === hylteTheme ? theme.palette.primary[800] : theme.palette.primary.main }}
            />
            <Switch>
              {routes
                .concat(publicMenuRoutes)
                .map(route => (
                  <Route
                    key={route.name}
                    path={route.path}
                    component={route.component}
                    exact={route.exact}
                    show={route.show}
                  />
                ))}
              {userRoutes
                .concat(accountRoutes)
                .map(route => (
                  <ProtectedRoute
                    key={route.name}
                    path={route.path}
                    component={route.component}
                    allowedRoles={userRoles}
                    exact={route.exact}
                    show={route.show}
                    isAuthenticated={accounts.isAuthenticated}
                    role={accounts.profile.role}
                  />
                ))}
              {adminRoutes.map(route => (
                <ProtectedRoute
                  key={route.name}
                  path={route.path}
                  component={route.component}
                  allowedRoles={adminRoles}
                  exact={route.exact}
                  show={route.show}
                  isAuthenticated={accounts.isAuthenticated}
                  role={accounts.profile.role}
                />
              ))}
              {superAdminRoutes.map(route => (
                <ProtectedRoute
                 key={route.name}
                 path={route.path}
                 component={route.component}
                 allowedRoles={superAdminRoles}
                 exact={route.exact}
                 show={route.show}
                 isAuthenticated={accounts.isAuthenticated}
                 role={accounts.profile.role}
                />
              ))}
              <Route component={NotFound} />
            </Switch>
            <GlobalMessageSnackbar />
          </MuiPickersUtilsProvider>
        </MuiThemeProvider>
      </Router>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(App)



// WEBPACK FOOTER //
// ./src/app.js